import { useState, useEffect } from "react";

const systemFeatures = [
  {
    title: "Gerenciamento de Contratos",
    description: "Controle completo de contratos de locação com ciclo de vida, reajustes automáticos e alertas de vencimento",
    features: [
      "Contratos digitais",
      "Reajustes automáticos",
      "Alertas de vencimento",
      "Histórico completo"
    ],
    icon: "📄"
  },
  {
    title: "Cobranças Automatizadas",
    description: "Geração automática de boletos e PIX, controle de inadimplência e repasses automáticos",
    features: [
      "Geração de boletos",
      "PIX automático",
      "Controle de inadimplência",
      "Repasses automáticos"
    ],
    icon: "💳"
  },
  {
    title: "Centralização de Documentos",
    description: "Armazene e gerencie todos os documentos de forma centralizada com validade e alertas",
    features: [
      "Armazenamento seguro",
      "Validade de documentos",
      "Alertas de expiração",
      "Acesso rápido"
    ],
    icon: "📁"
  },
  {
    title: "Histórico de Pagamentos",
    description: "Acompanhe todo o histórico de pagamentos de contas e locações de forma detalhada",
    features: [
      "Histórico completo",
      "Relatórios detalhados",
      "Rastreabilidade",
      "Exportação de dados"
    ],
    icon: "📊"
  },
  {
    title: "Locação de Cotas Imobiliárias",
    description: "Gerencie cotas imobiliárias, frações e timeshares com pagamento via cartão de crédito",
    features: [
      "Gestão de cotas",
      "Pagamento via cartão",
      "Parcelamento",
      "Controle de cotistas"
    ],
    icon: "📈"
  },
  {
    title: "Gerenciamento de Condomínios",
    description: "Administração completa de condomínios, aluguel de espaços comuns e áreas de lazer",
    features: [
      "Gestão completa",
      "Aluguel de espaços",
      "Cobrança automatizada",
      "Recuperação de crédito"
    ],
    icon: "🏢"
  },
  {
    title: "Análise de Crédito",
    description: "Motor de crédito integrado com consultas em SERASA, SPC e Receita Federal para análise completa",
    features: [
      "Consulta automática",
      "Score de crédito",
      "Análise de risco",
      "Recomendações inteligentes"
    ],
    icon: "🔐"
  },
  {
    title: "Busca Inteligente por IA",
    description: "Descreva o imóvel desejado e o sistema busca automaticamente com classificação semântica",
    features: [
      "Busca por perfil",
      "Classificação semântica",
      "Múltiplos portais",
      "Resultados precisos"
    ],
    icon: "🔍"
  },
  {
    title: "Gestão de Locadores",
    description: "Cadastro completo de proprietários com histórico de contratos e repasses",
    features: [
      "Cadastro completo",
      "Histórico de contratos",
      "Controle de repasses",
      "Relatórios financeiros"
    ],
    icon: "👤"
  },
  {
    title: "Gestão de Locatários",
    description: "Controle completo de inquilinos com histórico de pagamentos e análise de perfil",
    features: [
      "Cadastro detalhado",
      "Histórico de pagamentos",
      "Análise de perfil",
      "Alertas personalizados"
    ],
    icon: "🏠"
  },
  {
    title: "Contas a Pagar",
    description: "Controle financeiro completo com categorização, vencimentos e relatórios",
    features: [
      "Controle de despesas",
      "Alertas de vencimento",
      "Categorização",
      "Relatórios detalhados"
    ],
    icon: "💳"
  },
  {
    title: "Vistorias e Inspeções",
    description: "Registro completo de vistorias de entrada e saída com fotos e laudos",
    features: [
      "Vistorias digitais",
      "Fotos e laudos",
      "Checklist completo",
      "Histórico de inspeções"
    ],
    icon: "🔍"
  },
  {
    title: "Manutenções e Ordens de Serviço",
    description: "Controle de manutenções preventivas e corretivas com ordens de serviço",
    features: [
      "Ordens de serviço",
      "Manutenção preventiva",
      "Controle de custos",
      "Histórico completo"
    ],
    icon: "🔧"
  }
];

export default function DynamicPortalText() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setIsVisible(false);
      setTimeout(() => {
        setCurrentIndex((prev) => (prev + 1) % systemFeatures.length);
        setIsVisible(true);
      }, 300);
    }, 8000); // Muda a cada 8 segundos

    return () => clearInterval(interval);
  }, []);

  const current = systemFeatures[currentIndex];

  return (
    <div 
      className="dynamic-portal-text"
      style={{
        marginTop: "2rem",
        padding: "1.5rem",
        background: "linear-gradient(135deg, rgba(0, 86, 179, 0.1) 0%, rgba(34, 139, 34, 0.1) 100%)",
        borderRadius: "var(--radius-lg)",
        border: "1px solid rgba(0, 86, 179, 0.2)",
        transition: "opacity 0.3s ease, transform 0.3s ease",
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? "translateY(0)" : "translateY(-10px)"
      }}
    >
      <div style={{ textAlign: "center" }}>
        <div style={{ 
          fontSize: "1.3rem", 
          fontWeight: 700, 
          color: "var(--brand-blue)",
          marginBottom: "0.75rem",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "0.75rem"
        }}>
          <span style={{ fontSize: "1.8rem" }}>{current.icon}</span>
          <span>{current.title}</span>
        </div>
        
        <p style={{ 
          color: "var(--text-secondary)", 
          fontSize: "1rem",
          marginBottom: "1rem",
          lineHeight: 1.6,
          maxWidth: "600px",
          margin: "0 auto 1rem"
        }}>
          {current.description}
        </p>

        <div style={{ 
          display: "flex", 
          flexWrap: "wrap", 
          gap: "0.5rem", 
          justifyContent: "center",
          marginTop: "1rem"
        }}>
          {current.features.map((feature, index) => (
            <span
              key={index}
              style={{
                padding: "0.4rem 0.8rem",
                background: "rgba(255, 255, 255, 0.7)",
                borderRadius: "var(--radius-md)",
                fontSize: "0.85rem",
                color: "var(--text-primary)",
                border: "1px solid rgba(0, 86, 179, 0.2)",
                fontWeight: 500
              }}
            >
              ✓ {feature}
            </span>
          ))}
        </div>

        <div style={{ 
          display: "flex", 
          gap: "0.5rem", 
          justifyContent: "center",
          marginTop: "1rem"
        }}>
          {systemFeatures.map((_, index) => (
            <div
              key={index}
              style={{
                width: index === currentIndex ? "24px" : "8px",
                height: "8px",
                borderRadius: "4px",
                background: index === currentIndex ? "var(--brand-blue)" : "var(--border)",
                transition: "all 0.3s ease",
                cursor: "pointer"
              }}
              onClick={() => {
                setIsVisible(false);
                setTimeout(() => {
                  setCurrentIndex(index);
                  setIsVisible(true);
                }, 300);
              }}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
